import * as React from 'react';
import type { SVGProps } from 'react';

const SvgCalendar = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" fill="none" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M18.429 2.884H5.57C3.656 2.884 2 4.362 2 6.307V18.42c0 1.946 1.656 3.423 3.571 3.423H18.43c1.915 0 3.571-1.477 3.571-3.423V6.307c0-1.946-1.656-3.423-3.571-3.423ZM16 2v3.769M8 2v3.769M3 8.537h18"
    />
  </svg>
);
export default SvgCalendar;
